/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplate/Content/Loading"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={10}
 borderBottomRightRadius={10}
 borderTopLeftRadius={10}
 borderTopRightRadius={10}
 marginTop={dtSpaceS}
 height={10}
 width={150}
/>
{children}
</React.Fragment>)
}